export default __webpack_public_path__ + "static/media/Java.e637c895.jpg";